import { getLocalApi } from "./localApi";
import { ProductOffering } from "app/shared/model/ProductOffering";
import apiConfig from "app/api/apiConfig.json";

function extractSchoolId(schoolCode: string): string {
    const cleaned = schoolCode.replace(/^School-/i, '').trim();
    const match = cleaned.match(/\d+$/);
    if (match) {
        return match[0];
    }
    const anyNumber = cleaned.match(/\d+/);
    if (anyNumber) {
        return anyNumber[0];
    }
    return cleaned;
}

export interface GetOfferingsMinimalOptions {
    activeOnly?: boolean;
    divisionId?: number;
    dateFrom?: string;
    dateTo?: string;
}

export async function getOfferingsMinimal(schoolId: string[], options?: GetOfferingsMinimalOptions) {
    const localApi = await getLocalApi();

    const numericIds = schoolId.map(extractSchoolId);
    const params = new URLSearchParams();
    params.set('schoolIds', numericIds.join(','));
    if (options?.activeOnly === true) {
        params.set('activeOnly', 'true');
    }
    if (options?.divisionId !== undefined && options.divisionId > 0) {
        params.set('divisionId', String(options.divisionId));
    }
    if (options?.dateFrom) {
        params.set('dateFrom', options.dateFrom);
    }
    if (options?.dateTo) {
        params.set('dateTo', options.dateTo);
    }
    const query = params.toString();
    return await localApi.fetchList(
        apiConfig.products_get_offerings_by_school + '?' + query,
         mapProductOffering,
         'Failed to fetch product offerings');
}

function mapProductOffering(offeringDto: any) : ProductOffering {
    const name = offeringDto.name ?? offeringDto.Name;
    return {
        schoolId: offeringDto.schoolId ?? offeringDto.SchoolId,
        productId: offeringDto.productId ?? offeringDto.ProductId,
        ...(name ? { name: String(name) } : {}),
    }
}

export async function getOfferingsWithProducts(schoolId: string[]) {
    const localApi = await getLocalApi();

    const numericIds = schoolId.map(extractSchoolId);
    const schoolIdList = encodeURIComponent(numericIds.join(','));
    const endpoint = apiConfig.products_get_offerings_by_school + '?schoolIds=' + schoolIdList;
    
    return await localApi.fetchList(
        endpoint,
        (dto: any) => dto,
        'Failed to fetch product offerings'
    );
}